import React, { ReactElement, useEffect } from "react";
import "bootstrap/scss/bootstrap.scss";
import "../src/styles/main.scss";
import "antd/dist/antd.css";
import Routes from "./routes/routes";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { LOGOUT } from "./redux/auth/authType";

const App = (): ReactElement => {
  const dispatch = useDispatch();

  function checkIdleness() {
    var t: any;
    window.onload = timerReset;
    window.onmousemove = timerReset;
    window.onmousedown = timerReset; // catches touchscreen presses as well
    window.ontouchstart = timerReset; // catches touchscreen swipes as well
    window.onclick = timerReset; // catches touchpad clicks as well
    window.onkeydown = timerReset;
    window.addEventListener("scroll", timerReset, true); // improved; see comments

    function writeYourFunction() {
      Cookies.remove("authToken", { path: "/" });
      Cookies.remove("services", { path: "/" });
      dispatch({
        type: LOGOUT,
        payload: {
          token: null,
        },
      });
    }

    function timerReset() {
      clearTimeout(t);
      t = setTimeout(writeYourFunction, 3600000); // time is in milliseconds
    }
  }

  useEffect(() => {
    checkIdleness();
  }, []);

  
  return (
    <React.Fragment>
      <Routes />
    </React.Fragment>
  );
};

export default App;
